import { SvgIcon } from "@mui/material";
import {useCallback, useEffect, useMemo, useRef, useState} from "react";

interface IAnimatedLoaderProps {
    size?: string
}

interface CircleState {
    radius: number
    direction: number
    rotation: number
    speed: number
    radiusSpeed: number
    minRadius: number
    maxRadius: number
}

const createRandomCircle = (): CircleState => ({
    radius: 40 + Math.random() * 20,
    direction: Math.random() > 0.5 ? 1 : -1,
    rotation: Math.random() * 360,
    speed: 1.5 + Math.random() * 2,
    radiusSpeed: 0.3 + Math.random() * 0.4,
    minRadius: 35 + Math.random() * 10,
    maxRadius: 55 + Math.random() * 10,
})

export const AnimatedLoader = ({size}: IAnimatedLoaderProps) => {
    const initialCircles = useMemo(() => [
        createRandomCircle(),
        createRandomCircle(),
        createRandomCircle(),
    ], []);

    const [circles, setCircles] = useState<CircleState[]>(initialCircles);
    const intervalRef = useRef<ReturnType<typeof setInterval> | null>(null);
    const startAnimation = useCallback(() => {

        if (intervalRef.current) clearInterval(intervalRef.current);

        intervalRef.current = setInterval(() => {
            setCircles(prev => prev.map(circle => {
                let newRadius = circle.radius + circle.direction * circle.radiusSpeed;
                let newDirection = circle.direction;

                if (newRadius >= circle.maxRadius) {
                    newDirection = -1;
                    newRadius = circle.maxRadius;
                } else if (newRadius <= circle.minRadius) {
                    newDirection = 1;
                    newRadius = circle.minRadius;
                }

                return {
                    ...circle,
                    radius: newRadius,
                    direction: newDirection,
                    rotation: circle.rotation + circle.speed,
                };
            }));
        }, 50);
    }, []);


    useEffect(() => {
        startAnimation();


        return () => {
            if (intervalRef.current) clearInterval(intervalRef.current);
        };
    }, [startAnimation]);


    return (
        <SvgIcon viewBox="0 0 370 370" sx={{ width: size, height: size }} component="svg">
            <g transform={`rotate(${circles[0].rotation} 185 185)`}>
                <g filter="url(#filter0_f_9288_59582)">
                    <circle cx="150" cy="220" r={circles[0].radius} fill="#8B5CF6" />
                </g>
            </g>
            <g transform={`rotate(${circles[1].rotation} 185 185)`}>
                <g filter="url(#filter1_f_9288_59582)">
                    <circle cx="220" cy="220" r={circles[1].radius} fill="#06B6D4" />
                </g>
            </g>
            <g transform={`rotate(${circles[2].rotation} 185 185)`}>
                <g filter="url(#filter2_f_9288_59582)">
                    <circle cx="200" cy="150" r={circles[2].radius} fill="#F472B6" />
                </g>
            </g>
            <defs>
                <filter
                    id="filter0_f_9288_59582"
                    x="-200"
                    y="-200"
                    width="770"
                    height="770"
                    filterUnits="userSpaceOnUse"
                    primitiveUnits="userSpaceOnUse"
                    colorInterpolationFilters="sRGB"
                >
                    <feFlood flood-opacity="0" result="BackgroundImageFix" />
                    <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
                    <feGaussianBlur stdDeviation="50" result="effect1_foregroundBlur_9288_59582" />
                </filter>
                <filter
                    id="filter1_f_9288_59582"
                    x="-200"
                    y="-200"
                    width="770"
                    height="770"
                    filterUnits="userSpaceOnUse"
                    primitiveUnits="userSpaceOnUse"
                    colorInterpolationFilters="sRGB"
                >
                    <feFlood flood-opacity="0" result="BackgroundImageFix" />
                    <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
                    <feGaussianBlur stdDeviation="50" result="effect1_foregroundBlur_9288_59582" />
                </filter>
                <filter
                    id="filter2_f_9288_59582"
                    x="-200"
                    y="-200"
                    width="770"
                    height="770"
                    filterUnits="userSpaceOnUse"
                    primitiveUnits="userSpaceOnUse"
                    colorInterpolationFilters="sRGB"
                >
                    <feFlood flood-opacity="0" result="BackgroundImageFix" />
                    <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
                    <feGaussianBlur stdDeviation="50" result="effect1_foregroundBlur_9288_59582" />
                </filter>
            </defs>
        </SvgIcon>
    )
};
